import type { Observable } from 'rxjs/Observable';
import { fetchJson$ } from '@atlassian/jira-servicedesk-common/src/utils/fetch';
import type { TicketTypesRestResponse } from '../../common/types';

export const getRequestTypesUrl = (projectId: number) =>
	`/rest/servicedesk/1/servicedesk/${projectId}/request-types?isValidOnly=true`;

const getTicketTypesRest = (projectId: number): Observable<TicketTypesRestResponse> =>
	fetchJson$(getRequestTypesUrl(projectId));

export default getTicketTypesRest;
